<template>
  <div class="home" v-loading="isLoading">
    <div
      class="tip-dialog"
      @mouseleave="mouseLeave"
      @mouseenter="mouseEnter"
      id="tip-dialog"
      v-show="showDialog"
    >
      <!--    <div class="tip-dialog" @mouseleave="mouseLeave" @mouseenter="mouseEnter" id="tip-dialog" v-show="false">-->
      <div class="event-detail-wrap" id="dialog-hov">
        <div class="detail-header">
          <div class="detail-title">
            <div class="detail-title-icon">
              <svg class="detail-title-icon-svg" aria-hidden="true">
                <use :href="titleIcon"></use>
              </svg>
            </div>
            <div @click="goDetail('S', 'name')" class="detail-title-text">
              {{ showDialogEvent.title }}
            </div>
          </div>
        </div>

        <div class="detail-info-list" v-loading="miniShow">
          <div v-for="(item,index) in tipContent" class="detail-item" :key="index">
            <div class="detail-item-k">{{ item.labelname }}</div>
            <div
              @click="goDetail(item.fieldtype, item.fieldname)"
              :class="
                isJump(item.fieldtype, item.fieldname)
                  ? 'detail-item-v detail-item-v-active'
                  : 'detail-item-v'
              "
              v-if="
                item.fieldtype === 'Y' ||
                item.fieldname === 'relateid' ||
                item.fieldname === 'whoid'
              "
            >
              <span v-if="item.fieldtype == 'F'">{{
                tipData[item.fieldname + "ccname"] | datetimeFormat(countryCode)
              }}</span>
              <span v-else-if="item.fieldtype == 'D'">{{
                tipData[item.fieldname + "ccname"] | dateFormat(countryCode)
              }}</span>
              <span v-else>{{ tipData[item.fieldname + "ccname"] }}</span>
            </div>
            <div
              @click="goDetail(item.fieldtype, item.fieldname)"
              :class="
                isJump(item.fieldtype, item.fieldname)
                  ? 'detail-item-v detail-item-v-active'
                  : 'detail-item-v'
              "
              v-else
            >
              <span v-if="item.fieldtype == 'F'">{{
                tipData[item.fieldname] | datetimeFormat(countryCode)
              }}</span>
              <span v-else-if="item.fieldtype == 'D'">{{
                tipData[item.fieldname] | dateFormat(countryCode)
              }}</span>
              <span v-else>{{ tipData[item.fieldname] }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <FullCalendar
      ref="fullCalendar"
      style="width: 100%; height: 100%"
      :options="calendarOptions"
    />
  </div>
</template>

<script>
/**
 * @description: 日历组件-周视图
 */
import { getAllItems, getEditPermissions, getFromDetail,save } from "../api.js";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import * as Time from "@/utils/time";

export default {
  name: "Week",
  components: {
    FullCalendar,
  },
  props: ["showDialog"],
  data() {
    return {
      // 图标
      titleIcon: "#icon-cloudtab6_norm",
      // 事件悬浮窗
      miniShow: false,
      // 悬浮窗内容
      tipContent: [], 
      // 悬浮窗数据
      tipData: {},
      // 加载中
      isLoading: false,
      // 定时器
      timer: null,
      // 定时器2
      timer2: null, 
      // 鼠标是否在弹窗里面
      isInDialog: false, 
      // 选中事件
      showDialogEvent: {},
      calendarApi: null,
      // 日历组件配置
      calendarOptions: {
        // 当前时间线
        nowIndicator: true, 
        // 以星期日为第一天
        firstDay: "0", 
        // 语言
        locale:
          this.$store.state.userInfoObj.language === "jp"
            ? "ja"
            : this.$store.state.userInfoObj.language,
        // 全天事件的文本
        allDayText: "", 
        // 插件
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
        // 视图类型
        initialView: "timeGridWeek",
        // 设置视图中的事件显示是否可以重叠覆盖
        slotEventOverlap: false, 
        // 是否可以改变事件size
        eventDurationEditable: false, 
        // 是否可编辑
        editable: true,
        // 是否可选择
        selectable: true,
        // 数据格式
        events: [
          // { title: '开学安排1', start: '2020-09-09 08:16:19',end: '2020-09-09 11:36:19', color:'red',className:'dayStyle' },
          // { title: '开学安排2', start: '2020-09-09 08:16:19',end: '2020-09-09 11:36:19', color:'red',className:'dayStyle' },
        ],
        // 日期点击事件
        dateClick: this.handleDateClick,
        // 条目点击事件
        eventClick: this.handleEventClick,
        // 鼠标离开条目
        eventMouseLeave: this.handleEventLeave,
        // 鼠标移入条目
        eventMouseEnter: this.handleEventEnter,
        // 条目拖拽事件
        eventDrop: this.handleEventDrop,
        // 事件显示样式（短时间的事件去除点显示）
        eventDisplay: "block", 
        // 事件默认颜色
        eventColor: "#378006", 
      },
      // 日期格式化
      dateFormat: Time.dateFormat(this.$cookies.get("countryCode")),
      // 日期时间格式化
      datetimeFormat: Time.datetimeFormat(this.$cookies.get("countryCode")),
      // 时间格式化
      timeFormat: Time.timeFormat(this.$cookies.get("countryCode")),
      // 国家码
      countryCode: this.$cookies.get("countryCode"),
    };
  },
  methods: {
    /**
     * @description: 判断字段是否可跳转
     */
    isJump(fieldtype, fieldname) {
      if (
        (fieldtype === "S" && fieldname === "name") ||
        fieldtype === "Y" ||
        fieldtype === "M"
      ) {
        // 字段类型为S,Y,M，或者属于name字段即可跳转
        return true;
      } else {
        return false;
      }
    },
    /**
     * @description: 跳转详情页
     */
    goDetail(type, name) {
      if (this.isJump(type, name)) {
        if (name === "name") {
          this.$router.push({
            path: `/commonObjects/detail/${this.tipData.id}/DETAIL`,
          });
        } else {
          this.$router.push({
            path: `/commonObjects/detail/${this.tipData[name]}/DETAIL`,
          });
        }
      }
    },
    /**
     * @description: 关闭弹窗
     */
    closeDialog() {
      this.$emit("updateDialogStatus", "0");
    },
    /**
     * @description: 日期格式化
     */
    formateDate(datetime) {
      if (datetime === "" || datetime === undefined || datetime === null)
        return "";
      function addDateZero(num) {
        return num < 10 ? "0" + num : num;
      }
      var d = new Date(datetime);
      let formateDatetime =
        d.getFullYear() +
        "-" +
        addDateZero(d.getMonth() + 1) +
        "-" +
        addDateZero(d.getDate()) +
        " " +
        addDateZero(d.getHours()) +
        ":" +
        addDateZero(d.getMinutes()) +
        ":" +
        addDateZero(d.getSeconds());
      return formateDatetime;
    },
    /**
     * @description: 获取悬浮窗内容
     */
    getTipContent(eventId) {
      let option = {
        id: eventId,
        operation: "MINI",
      };
      getFromDetail(option).then((res) => {
        this.tipContent = res.data.fieldList;
        this.tipData = res.data.data;
        this.titleIcon = "#icon-" + res.data.tabStyle;
        if (this.tipData.isremider) {
          this.tipData.isremider =
            this.tipData.isremider === "true" ? "是" : "否";
        }
        this.miniShow = false;
      });
    },
    /**
     * @description: 鼠标移入条目事件
     */
    handleEventEnter(info) {
      //
      this.miniShow = true;
      this.tipContent = [];
      this.tipData = {};
      if (this.timer) clearTimeout(this.timer);
      if (this.timer2) clearTimeout(this.timer2);
      var dialogEl = document.getElementById("tip-dialog");
      // 处理弹窗位置
      if (document.body.clientWidth - info.jsEvent.clientX < 270) {
        let newPixel = info.jsEvent.clientX - 270;
        dialogEl.style.left = newPixel + "px";
        if (document.body.clientHeight - info.jsEvent.clientY < 270) {
          let newPixel = info.jsEvent.clientY - 240;
          dialogEl.style.top = newPixel + "px";
          // dialogEl.style.top =
        } else {
          dialogEl.style.top = info.jsEvent.clientY + "px";
        }
      } else {
        dialogEl.style.left = info.jsEvent.clientX + "px";
        if (document.body.clientHeight - info.jsEvent.clientY < 270) {
          let newPixel = info.jsEvent.clientY - 240;
          dialogEl.style.top = newPixel + "px";
        } else {
          dialogEl.style.top = info.jsEvent.clientY + "px";
        }
      }
      this.timer2 = setTimeout(() => {
        this.$emit("updateDialogStatus", "1");
        this.getTipContent(info.event.id);
      }, 750);
      if (!this.isInDialog) {
        this.timer = setTimeout(() => {
          this.$emit("updateDialogStatus", "0");
        }, 10000);
      }
      this.showDialogEvent = info.event;
      this.showDialogEvent.startString = this.formateDate(
        this.showDialogEvent.start
      );
      this.showDialogEvent.endString = this.formateDate(
        this.showDialogEvent.end
      );
    },
    /**
     * @description: 鼠标移入弹窗事件
     */
    mouseLeave() {
      this.isInDialog = false;
      this.$emit("updateDialogStatus", "0");
    },
    /**
     * @description: 鼠标移入弹窗事件
     */
    mouseEnter() {
      this.isInDialog = true;
      clearTimeout(this.timer);
    },
    /**
     * 鼠标移出条目事件
     */
    handleEventLeave() {
      // if (this.isInDialog) {
      //   this.$emit('updateDialogStatus', '0')
      // }
    },
    /**
     * @description: 拖拽事件的回调
     */
    async handleEventDrop(info) {
      let res = await getEditPermissions({ id: info.event.id });
      let hasEdit = res.data.modify;
      if (hasEdit) {
        let dateStart = new Date(info.event.start);
        let updatedStartDate = this.formateDate(dateStart);
        let updatedEndDate = null;
        if (info.event.end) {
          let dateEnd = new Date(info.event.end);
          updatedEndDate = this.formateDate(dateEnd);
        }

        let option = { objectApi: "", data: "" };
        option.objectApi = info.event.extendedProps.CCObjectAPI;
        if (info.event.extendedProps.CCObjectAPI === "Event") {
          let eventStr = {
            id: info.event.id,
            begintime: updatedStartDate,
            endtime: updatedEndDate || updatedStartDate,
          };
          option.data = "[" + JSON.stringify(eventStr) + "]";
        } else {
          if (
            info.event.extendedProps.createdate ||
            info.event.extendedProps.lastmodifydate
          ) {
            info.revert();
            this.$message({
              showClose: true,
              message: this.$i18n.t("vue_label_calendar_notice_timecantmove"),
              type: "warning",
            });
            return;
          } else {
            let objStr = {
              id: info.event.id,
            };
            objStr[info.event.extendedProps.beginfield] = updatedStartDate;
            option.data = "[" + JSON.stringify(objStr) + "]";
          }
        }
        this.editEvent(option);
      } else {
        info.revert();
      }
    },
    /**
     * @description: 日期点击事件
     */
    handleDateClick(arg) {
      let date = this.formateDate(arg.date);
      this.$emit("updateDialogStatus", "0");
      this.$emit("openNewEvent", date);
    },
    /**
     * @description: 条目点击事件
     */
    handleEventClick(info) {
      let obj = {
        id: info.event.id,
        objectApi: info.event.extendedProps.CCObjectAPI,
        objId: "event",
        type: "event",
      };
      this.$emit("updateDialogStatus", "0");
      this.$emit("goItemDetail", obj);
      // this.$router.push({
      //   path: `/commonObjects/detail/${obj.id}/DETAIL`
      // })
    },
    /**
     * @description: 父组件点击事件
     */
    parentHandleClick(flag) {
      if (flag == -1) {
        this.calendarApi.prev();
      } else if (flag == 1) {
        this.calendarApi.next();
      } else if (flag == 0) {
        this.calendarApi.today();
      }

      this.getHeaderDate(
        this.calendarApi.currentData.viewTitle,
        this.calendarApi.currentData.currentDate
      );
    },
    /**
     * @description: 父组件传递的刷新视图
     */
    parentRefresh() {
      //
      this.getHeaderDate(
        this.calendarApi.currentData.viewTitle,
        this.calendarApi.currentData.currentDate
      );
    },
    /**
     * @description: 父组件点击小日历跳转
     */
    parentGoDate(date) {
      this.calendarApi.gotoDate(date);
      this.getHeaderDate(
        this.calendarApi.currentData.viewTitle,
        this.calendarApi.currentData.currentDate
      );
    },
    /**
     * @description: 解决切换侧边栏不能自适应的问题
     */
    parentHandleResize() {
      this.calendarApi.incrementDate("00:00:01");
    },
    /**
     * @description: 获取真实时间
     */
    getRealDate(dateData) {
      let date = new Date(dateData);
      let realDate = new Date(date.getTime() - 8 * 60 * 60 * 1000);
      let y = realDate.getFullYear();
      let m =
        realDate.getMonth() + 1 < 10
          ? "0" + (realDate.getMonth() + 1)
          : realDate.getMonth() + 1;
      let d =
        realDate.getDate() < 10 ? "0" + realDate.getDate() : realDate.getDate();
      // let hh = realDate.getHours() < 10 ? "0" + date.getHours() : realDate.getHours();
      // let mm = realDate.getMinutes()
      // let ss = realDate.getSeconds()
      return y + "-" + m + "-" + d;
    },
    /**
     * @description: 获取左上角日期并回传给父组件
     */
    getHeaderDate(date, day) {
      this.$emit("headerDate", date, this.getRealDate(day));
      let dateObj = { showtype: "week" };
      // 获取某天所在的星期起始
      let res = this.getWeekStartAndEnd(day);
      dateObj.startdate = res.start;
      dateObj.enddate = res.end;
      this.getAllItem(dateObj);
    },
    /**
     * @description: 获取某天所在的星期起始
     */
    getWeekStartAndEnd(timestamp) {
      const oneDayTime = 1000 * 60 * 60 * 24;
      const today = timestamp ? new Date(timestamp) : new Date();
      const todayDay = today.getDay();
      const startDate = new Date(today.getTime() - oneDayTime * todayDay);
      const endDate = new Date(today.getTime() + oneDayTime * (6 - todayDay));
      const start = format(startDate);
      const end = format(endDate);
      function format(f) {
        let d = new Date(f);
        return d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();
      }
      return { start, end };
    },
    /**
     * @description: 获取相差天数
     */
    timeFn(d1, d2) {
      if (!d1 || !d2) {
        return 0;
      }
      // if (!d1 || !d2) {
      //   return 0;
      // }
      //di作为一个变量传进来
      //如果时间格式是正确的，那下面这一步转化时间格式就可以不用了
      let dateBegin = new Date(d1.replace(/-/g, "/")); //将-转化为/，使用new Date
      let dateEnd;
      if (d2) {
        dateEnd = new Date(d2.replace(/-/g, "/")); //将-转化为/，使用new Date
      } else {
        dateEnd = dateBegin;
      }
      let dateDiff = dateEnd.getTime() - dateBegin.getTime(); //时间差的毫秒数
      //计算出相差天数
      return Math.floor(dateDiff / (24 * 3600 * 1000));
    },
    /**
     * @description: 拖拽后的编辑
     */
    async editEvent(data) {
      let res = await save(data);
      if (res.data && res.data[0] && res.data[0].isSaveSuccess === "true") {
        // this.getHeaderDate(this.calendarApi.currentData.viewTitle, this.calendarApi.currentData.currentDate)
        this.$message.success(this.$i18n.t("savesuccess"));
      } else {
        if(res.data[0].errormessage.includes('illegal_field_apiname')){
          // 值不存在或与筛选条件不匹配
          this.$message.error(this.$i18n.t("c2420"));
        }else{
          this.$message.error(
          res.data[0].errormessage || this.$i18n.t("chatter.save.f")
        );
        }
       
      }
    },
    /**
     * @description: 获取所有条目
     */
    async getAllItem(option) {
      this.isLoading = true;
      let res = await getAllItems(option);
      let list = res.data.list;
      let array = [];
      list.map((item) => {
        if (item.data) {
          item.data.map((itemBase) => {
            // itemBase.color = item.color
            if (item.type === "myevent") {
              itemBase.color = "rgb(88, 22, 139)";
              if (this.timeFn(itemBase.begintime, itemBase.endtime) >= 1) {
                itemBase.allDay = true;
              }
            }
            if (itemBase.beginfield) {
              itemBase.baseTime = itemBase[itemBase.beginfield];
            }
            if (itemBase.showfield) {
              itemBase.baseTitle = itemBase[itemBase.showfield]||this.$i18n.t('label.json.string.null');
            }
          });
          array.push(...item.data);
        }
        //如果isStartGreaterThanEnd为true,则该对象下的日历有异常数据(开始时间大于结束时间)
        if (
          item.isStartGreaterThanEnd &&
          item.isStartGreaterThanEnd == "true"
        ) {
          this.$Bus.$emit("is-Abnormal-data", item.id);
        }
      });

      array.map((item) => {
        item.title = item.subject || item.baseTitle;
        item.start = item.begintime || item.baseTime;
        item.end = item.endtime || item.baseTime;
        if (item.lightColor === "1") {
          item.className = "lightColor";
        }
      });
      //
      this.calendarOptions.events = array;
      this.isLoading = false;
    },
  },
  mounted() {
    if (this.$store.state.userInfoObj.language === "jp") {
      this.calendarOptions.locale = "ja";
    } else {
      this.calendarOptions.locale = this.$store.state.userInfoObj.language;
    }
    this.calendarApi = this.$refs.fullCalendar.getApi();
    this.getHeaderDate(
      this.calendarApi.currentData.viewTitle,
      this.calendarApi.currentData.currentDate
    );
  },
};
</script>
<style lang="scss" scoped>
@import "./calendarDialogCss/calendarDialog.scss";
::v-deep .fc .fc-col-header-cell-cushion {
  color: #999999;
}
::v-deep .fc-theme-standard th {
  height: 34px;
  vertical-align: inherit;
}
::v-deep .lightColor {
  opacity: 0.5;
}
::v-deep .fc-h-event .fc-event-main-frame {
  display: flex;
  height: 25px;
  align-items: center;
  padding: 10px;
}
::v-deep .fc-daygrid-event {
  border-radius: 15px;
}
::v-deep .fc .fc-toolbar.fc-header-toolbar {
  display: none;
}
::v-deep .fc-direction-ltr .fc-daygrid-event.fc-event-end,
.fc-direction-rtl .fc-daygrid-event.fc-event-start {
  margin-right: 5px;
}
::v-deep .fc-direction-ltr .fc-daygrid-event.fc-event-start,
.fc-direction-rtl .fc-daygrid-event.fc-event-end {
  margin-left: 5px;
}
::v-deep .fc-timegrid-event .fc-event-time {
  white-space: inherit;
}
::v-deep .fc-v-event .fc-event-main:hover {
  color: dodgerblue;
}
::v-deep .fc-event-title-container:hover {
  color: dodgerblue;
}
::v-deep .fc .fc-scroller {
  max-height: 120px;
}
::v-deep .fc .fc-scroller-liquid-absolute {
  max-height: none;
}
::v-deep .fc .fc-scrollgrid-section,
.fc .fc-scrollgrid-section > td,
.fc .fc-scrollgrid-section table {
  height: null;
}
::v-deep .fc-media-screen .fc-timegrid-cols > table {
  height: 100%;
}
//隐藏滚动条
::v-deep .fc-scrollgrid-section-header td .fc-scroller-harness .fc-scroller {
  overflow: hidden !important;
}
::v-deep .fc-scrollgrid-section-body td .fc-scroller-harness .fc-scroller {
  overflow: hidden !important;
}
::v-deep
  .fc-scrollgrid-section-body
  td
  .fc-scroller-harness-liquid
  .fc-scroller-liquid-absolute {
  overflow: hidden scroll !important;
}
</style>
